<app-breadcrumb
  [title]="'Listado'"
  [items]="['Usuarios']"
  [active_item]="'Listado de usuarios Web'"
>
</app-breadcrumb>

<div class="card shadow-sm border-0 overflow-hidden">

  <!-- Header con gradiente -->
  <div class="card-header border-0 py-3 px-4 bg-gradient-primary">
    <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
      <div class="d-flex align-items-center gap-3">
        <div class="rounded-circle d-flex align-items-center justify-content-center"
          style="width:46px;height:46px;background:rgba(255,255,255,0.18);font-size:1.4rem;flex-shrink:0;">
          <i class="icofont icofont-users text-white"></i>
        </div>
        <div>
          <h5 class="text-white fw-bold mb-0" style="letter-spacing:.04em;">USUARIOS WEB</h5>
          <small class="text-white opacity-75">Gestión de cuentas y permisos</small>
        </div>
      </div>
      <span class="badge rounded-pill px-3 py-2 text-white"
        style="background:rgba(255,255,255,0.2);font-size:.82rem;">
        <i class="icofont icofont-users me-1"></i>{{ filteredUsers.length }} usuario(s)
      </span>
    </div>
  </div>

  <div class="card-body p-3 p-md-4">

    <!-- Toolbar -->
    <div class="row g-2 mb-4 align-items-center">
      <div class="col-auto">
        <button class="btn btn-success rounded-pill px-3 shadow-sm fw-semibold"
          (click)="abrirModalCrear(modalCrearUsuario)">
          <i class="icofont icofont-plus me-1"></i> Nuevo usuario
        </button>
      </div>
      <div class="col ms-auto" style="max-width:320px;">
        <div class="input-group shadow-sm">
          <span class="input-group-text bg-white border-end-0">
            <i class="fa fa-search text-muted"></i>
          </span>
          <input
            type="text"
            class="form-control border-start-0 ps-0"
            placeholder="Buscar usuario o email..."
            [(ngModel)]="searchText"
            (input)="filterByMultipleFields()"
          />
        </div>
      </div>
    </div>

    <!-- Spinner -->
    <div *ngIf="loading" class="d-flex flex-column align-items-center justify-content-center py-5">
      <div class="spinner-border text-primary mb-3" style="width:2.5rem;height:2.5rem;" role="status"></div>
      <span class="text-muted small">Cargando usuarios...</span>
    </div>

    <!-- Tabla -->
    <div class="table-responsive rounded-3 shadow-sm" *ngIf="!loading">
      <table class="table table-hover align-middle mb-0" style="font-size:.85rem;">
        <thead>
          <tr style="background:linear-gradient(135deg,#4f46e5,#7c3aed);">
            
            <th scope="col" sortable="username" (sort)="onSort($event)"
              class="text-white text-cente fw-semibold border-0 py-3" style="cursor:pointer;">USUARIO</th>
            <th scope="col" sortable="email" (sort)="onSort($event)"
              class="text-white fw-semibold border-0 py-3" style="cursor:pointer;">EMAIL</th>
            <th scope="col" class="text-center text-white fw-semibold border-0 py-3">ROL</th>
            <th scope="col" class="text-center text-white fw-semibold border-0 py-3">ESTADO</th>
            <th scope="col" class="text-center text-white fw-semibold border-0 py-3">2FA</th>
            <th scope="col" sortable="created_at" (sort)="onSort($event)"
              class="text-center text-white fw-semibold border-0 py-3" style="cursor:pointer;">CREADO</th>
            <th scope="col" class="text-center text-white fw-semibold border-0 py-3">ACCIONES</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of paginatedUsers" class="border-bottom">
          

            <!-- Usuario con avatar -->
            <td>
              <div class="d-flex align-items-center gap-2">
                <div class="user-avatar rounded-circle d-flex align-items-center justify-content-center fw-bold text-white"
                  style="width:34px;height:34px;font-size:.78rem;flex-shrink:0;
                         background:linear-gradient(135deg,#4f46e5,#7c3aed);">
                  {{ user.username?.charAt(0)?.toUpperCase() }}
                </div>
                <span class="fw-semibold">{{ user.username }}</span>
              </div>
            </td>

            <!-- Email -->
            <td class="text-dark" style="font-size:.82rem;">
              <i class="icofont icofont-email me-1 text-primary opacity-50"></i>{{ user.email }}
            </td>

            <!-- Rol -->
            <td class="text-center">
              <span *ngFor="let rol of user.roles"
                class="badge rounded-pill me-1 px-2"
                [ngClass]="rol.nombre === 'ADMIN' ? 'text-bg-danger' :
                            rol.nombre === 'USUARIO_TENANT' ? 'text-bg-warning' : 'text-bg-secondary'"
                style="font-size:.62rem;">
                {{ rol.nombre }}
              </span>
              <span *ngIf="!user.roles || user.roles.length === 0"
                class="badge bg-light text-secondary border" style="font-size:.72rem;">
                <i class="icofont icofont-minus-circle me-1"></i>Sin rol
              </span>
            </td>

            <!-- Estado -->
            <td class="text-center">
              <span class="badge  rounded-pill px-3"
                [ngClass]="user.estado === 1 ? 'text-bg-success' : 'text-bg-danger'"
                style="font-size:.62rem;">
                <i class="icofont me-1"
                  [ngClass]="user.estado === 1 ? 'icofont-check-circled' : 'icofont-close-circled'"></i>
                {{ user.estado === 1 ? 'Activo' : 'Inactivo' }}
              </span>
            </td>

            <!-- 2FA -->
            <td class="text-center">
              <span class="badge rounded-pill px-2"
                [ngClass]="user.two_factor_enabled ? 'text-bg-success' : 'text-bg-secondary'"
                style="font-size:.72rem;">
                <i class="icofont me-1"
                  [ngClass]="user.two_factor_enabled ? 'icofont-lock' : 'icofont-unlock'"></i>
                {{ user.two_factor_enabled ? 'On' : 'Off' }}
              </span>
            </td>

            <!-- Fecha -->
            <td class="text-center text-dark" style="font-size:.8rem;">
              <i class="icofont icofont-calendar me-1 opacity-50"></i>{{ formatDate(user.created_at) }}
            </td>

            <!-- Acciones -->
            <td class="text-center">
              <div class="d-flex justify-content-center gap-1">
                <button class="btn btn-sm btn-outline-primary rounded-pill" style="width:30px;height:30px;padding:0;"
                  (click)="editarUsuario(user)" ngbTooltip="Editar usuario">
                  <i class="icofont icofont-edit" style="font-size:.85rem;"></i>
                </button>
                <button class="btn btn-sm btn-outline-info rounded-pill" style="width:30px;height:30px;padding:0;"
                  (click)="abrirPermisos(user, modalPermisos)" ngbTooltip="Permisos">
                  <i class="icofont icofont-shield" style="font-size:.85rem;"></i>
                </button>
                <button class="btn btn-sm btn-outline-success rounded-pill" style="width:30px;height:30px;padding:0;"
                  (click)="abrirVehiculos(user, modalVehiculos)" ngbTooltip="Vehículos asignados"
                  *ngIf="!esAdmin(user)">
                  <i class="icofont icofont-car-alt-1" style="font-size:.85rem;"></i>
                </button>
               

                 <button class="btn btn-sm btn-outline-warning rounded-pill" style="width:30px;height:30px;padding:0;"
                  (click)="abrirContratistas(user, modalContratistas)" ngbTooltip="Contratistas asignados"
                  *ngIf="!esAdmin(user)">
                  <i class="icofont icofont-people" style="font-size:.85rem;"></i>
                </button>
                <button class="btn btn-sm btn-outline-secondary rounded-pill" style="width:30px;height:30px;padding:0;"
                  (click)="abrirObjetosContratos(user, modalObjetosContratos)" ngbTooltip="Objetos de contrato"
                  *ngIf="!esAdmin(user)">
                  <i class="icofont icofont-briefcase" style="font-size:.85rem;"></i>
                </button>
                <button class="btn btn-sm rounded-pill" style="width:30px;height:30px;padding:0;background:linear-gradient(135deg,#4f46e5,#7c3aed);border:none;"
                  (click)="impersonarUsuario(user)" ngbTooltip="Iniciar sesión como este usuario"
                  *ngIf="!esAdmin(user)">
                  <i class="icofont icofont-key" style="font-size:.85rem;color:#fff;"></i>
                </button>
                <button class="btn btn-sm btn-outline-danger rounded-pill" style="width:30px;height:30px;padding:0;"
                  (click)="inactivarUsuario(user)" ngbTooltip="Inactivar usuario">
                  <i class="icofont icofont-ban" style="font-size:.85rem;"></i>
                </button>
              </div>
            </td>
          </tr>

          <!-- Empty state inline -->
          <tr *ngIf="filteredUsers.length === 0">
            <td colspan="8" class="text-center py-5">
              <i class="icofont icofont-ui-user fs-1 text-secondary d-block mb-2 opacity-50"></i>
              <p class="text-muted mb-0">No se encontraron usuarios.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div class="d-flex flex-wrap justify-content-between align-items-center mt-3 gap-2" *ngIf="!loading && filteredUsers.length > 0">
      <small class="text-muted">
        Mostrando <strong>{{ (page-1)*pageSize + 1 }}</strong>–<strong>{{ page*pageSize > filteredUsers.length ? filteredUsers.length : page*pageSize }}</strong>
        de <strong>{{ filteredUsers.length }}</strong> usuarios
      </small>
      <ngb-pagination
        [(page)]="page"
        [pageSize]="pageSize"
        [collectionSize]="filteredUsers.length"
        [maxSize]="5"
        [rotate]="true"
        [boundaryLinks]="true">
      </ngb-pagination>
      <select class="form-select form-select-sm rounded-pill" style="width:130px;"
        [(ngModel)]="pageSize">
        <option [ngValue]="5">5 por página</option>
        <option [ngValue]="10">10 por página</option>
        <option [ngValue]="20">20 por página</option>
      </select>
    </div>

  </div>
</div>

<!-- Modal Permisos -->
<ng-template #modalPermisos let-modal>

  <!-- Header con gradiente y avatar -->
  <div class="modal-header border-0 text-white bg-gradient-primary">
    <div class="d-flex align-items-center gap-3">
      <div class="rounded-circle d-flex align-items-center justify-content-center"
        style="width:46px;height:46px;background:rgba(255,255,255,0.2);font-size:1.4rem;flex-shrink:0;">
        <i class="icofont icofont-shield-alt"></i>
      </div>
      <div>
        <h5 class="modal-title mb-0 fw-bold">Gestión de permisos</h5>
        <small class="opacity-75">{{ usuarioSeleccionado?.username }} &bull; {{ usuarioSeleccionado?.email }}</small>
      </div>
    </div>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body p-0">

    <!-- Loading -->
    <div *ngIf="loadingPermisos" class="d-flex flex-column align-items-center justify-content-center py-5">
      <div class="spinner-border text-primary mb-3" style="width:2.5rem;height:2.5rem;" role="status"></div>
      <span class="text-muted small">Cargando permisos...</span>
    </div>

    <ng-container *ngIf="!loadingPermisos">

      <!-- Instrucción -->
      <div class="px-4 pt-3 pb-2">
        <p class="mb-0 text-primary small">
          <i class="icofont icofont-info-circle me-1 text-primary"></i>
          Activa o desactiva los permisos y luego guarda los cambios.
        </p>
      </div>

      <!-- Sin permisos disponibles -->
      <div *ngIf="modulosPermisos.length === 0" class="text-center py-5 text-muted">
        <i class="icofont icofont-lock fs-1 d-block mb-2 text-secondary"></i>
        <p class="mb-0">No hay permisos disponibles para mostrar.</p>
      </div>

      <!-- Acordeón de módulos -->
      <div class="px-4 pb-4">
        <div class="accordion accordion-flush border rounded overflow-hidden" id="accordionPermisos"
          *ngIf="modulosPermisos.length > 0">

          <div class="accordion-item" *ngFor="let grupo of modulosPermisos; let i = index">

            <!-- Cabecera del módulo -->
            <h2 class="accordion-header" [id]="'heading-' + i">
              <button class="accordion-button py-2 px-3 fw-semibold"
                [class.collapsed]="!panelAbiertosPermisos.has(i)"
                [attr.aria-expanded]="panelAbiertosPermisos.has(i)"
                [attr.aria-controls]="'collapse-' + i"
                (click)="togglePanelPermiso(i)"
                style="font-size:.85rem;text-transform:uppercase;letter-spacing:.06em;cursor:pointer;">

                <span class="d-flex align-items-center gap-2 flex-grow-1">
                  <span class="rounded px-2 py-1 text-white"
                    style="background:linear-gradient(135deg,#4f46e5,#7c3aed);font-size:.7rem;">
                    <i class="icofont icofont-listine-dots"></i>
                  </span>
                  {{ grupo.modulo }}
                </span>

                <!-- Mini barra de progreso -->
                <span class="d-flex align-items-center gap-2 me-3">
                  <div class="progress" style="width:60px;height:6px;border-radius:3px;">
                    <div class="progress-bar"
                      style="background:linear-gradient(90deg,#4f46e5,#7c3aed);"
                      [style.width.%]="(contarActivos(grupo.permisos) / grupo.permisos.length) * 100">
                    </div>
                  </div>
                  <span class="badge rounded-pill"
                    [ngClass]="contarActivos(grupo.permisos) === grupo.permisos.length ? 'bg-success' :
                                contarActivos(grupo.permisos) === 0 ? 'bg-secondary' : 'bg-warning text-dark'"
                    style="font-size:.72rem;min-width:52px;text-align:center;">
                    {{ contarActivos(grupo.permisos) }}/{{ grupo.permisos.length }}
                  </span>
                </span>

              </button>
            </h2>

            <!-- Cuerpo del módulo -->
            <div [id]="'collapse-' + i" class="accordion-collapse collapse"
              [class.show]="panelAbiertosPermisos.has(i)"
              [attr.aria-labelledby]="'heading-' + i">
              <div class="accordion-body p-3" style="background:#fafbff;">
                <!-- Acciones rápidas del módulo -->
                <div class="d-flex gap-2 mb-2">
                  <button type="button" class="btn btn-xs px-2 py-1 text-white fw-semibold"
                    style="font-size:.72rem;background:linear-gradient(135deg,#4f46e5,#7c3aed);border:none;border-radius:6px;"
                    (click)="toggleTodosModulo(grupo.permisos, true)">
                    <i class="icofont icofont-check-alt me-1"></i>Seleccionar todos
                  </button>
                  <button type="button" class="btn btn-xs px-2 py-1 fw-semibold"
                    style="font-size:.72rem;border:1px solid #4f46e5;color:#4f46e5;background:#fff;border-radius:6px;"
                    (click)="toggleTodosModulo(grupo.permisos, false)">
                    <i class="icofont icofont-close-line me-1"></i>Desmarcar todos
                  </button>
                </div>
                <div class="row g-2">
                  <div class="col-12 col-md-6 col-xl-4" *ngFor="let permiso of grupo.permisos">
                    <label [for]="'perm-' + permiso.id"
                      class="d-flex align-items-start gap-2 p-2 rounded border h-100"
                      style="cursor:pointer;"
                      [style.border-color]="tienePermiso(permiso.id) ? '#4f46e5' : '#dee2e6'"
                      [style.background]="tienePermiso(permiso.id) ? '#eef2ff' : '#fff'">

                      <div class="pt-1">
                        <input
                          class="form-check-input m-0"
                          type="checkbox"
                          [id]="'perm-' + permiso.id"
                          [checked]="tienePermiso(permiso.id)"
                          (change)="togglePermiso(permiso.id, $event)"
                          style="width:1.1rem;height:1.1rem;cursor:pointer;accent-color:#4f46e5;">
                      </div>

                      <div class="overflow-hidden">
                        <div class="mb-1">
                          <span class="badge rounded-pill px-2"
                            [ngClass]="tienePermiso(permiso.id) ? 'text-bg-primary' : 'text-bg-light text-secondary'"
                            style="font-size:.68rem;font-family:monospace;">
                            {{ permiso.codigo.split('.')[1] || permiso.codigo }}
                          </span>
                        </div>
                        <p class="mb-0 text-primary lh-sm" style="font-size:.78rem;">
                          {{ permiso.descripcion || permiso.codigo }}
                        </p>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </ng-container>
  </div>

  <!-- Footer -->
  <div class="modal-footer border-top px-4 py-3" style="background:#f8f9ff;">
    <span class="text-muted small me-auto">
      <i class="icofont icofont-info-circle me-1"></i>
      {{ permisosUsuario.length }} permiso(s) seleccionado(s)
    </span>
    <button class="btn btn-outline-secondary btn-sm px-4" (click)="modal.dismiss()">Cancelar</button>
    <button class="btn btn-sm px-4 text-white fw-semibold bg-gradient-primary"
      (click)="guardarPermisos(modal)">
      <i class="icofont icofont-save me-1"></i> Guardar permisos
    </button>
  </div>

</ng-template>

<!-- Modal Crear Usuario -->
<ng-template #modalCrearUsuario let-modal>
  <div class="modal-header text-white border-0 bg-gradient-primary">
    <div class="d-flex align-items-center gap-3">
      <div class="rounded-circle d-flex align-items-center justify-content-center"
        style="width:42px;height:42px;background:rgba(255,255,255,0.2);font-size:1.3rem;flex-shrink:0;">
        <i class="icofont icofont-user text-white"></i>
      </div>
      <div>
        <h5 class="modal-title mb-0 fw-bold">Nuevo usuario</h5>
        <small class="opacity-75">Completa los datos para crear la cuenta</small>
      </div>
    </div>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body px-4 py-4">
    <div class="mb-3">
      <label class="form-label text-dark fw-semibold small text-uppercase" style="letter-spacing:.05em;">
        <i class="icofont icofont-user me-1 text-primary"></i> Usuario
      </label>
      <input id="new-username" type="text" class="form-control" placeholder="Nombre de usuario" autocomplete="off">
    </div>

    <div class="mb-3">
      <label class="form-label text-dark fw-semibold small text-uppercase" style="letter-spacing:.05em;">
        <i class="icofont icofont-email me-1 text-primary"></i> Email
      </label>
      <input id="new-email" type="email" class="form-control" placeholder="correo@ejemplo.com" autocomplete="off">
    </div>

     <div class="mb-3">
      <label class="form-label text-dark fw-semibold small text-uppercase" style="letter-spacing:.05em;">
        <i class="icofont icofont-users me-1 text-primary" style="color: #f0f8ff;"></i> Rol Usuario
      </label>
      <select id="new-role" class="form-select">
        <option value="">-- Sin rol --</option>
        <option *ngFor="let rol of roles" [value]="rol.id">{{ rol.nombre }}</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label text-dark fw-semibold small text-uppercase" style="letter-spacing:.05em;">
        <i class="icofont icofont-lock me-1 text-primary"></i> Contraseña
      </label>
      <div class="input-group">
        <input id="new-password" type="password" class="form-control" placeholder="Contraseña inicial" autocomplete="new-password"
          #newPass (input)="checkNewPassMatch(newPass.value, newPassConf.value)">
        <button class="btn btn-outline-secondary" type="button"
          onclick="const el=document.getElementById('new-password');el.type=el.type==='password'?'text':'password'">
          <i class="icofont icofont-eye"></i>
        </button>
      </div>
      <div class="form-text text-dark">Mínimo 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial.</div>
    </div>

    <div class="mb-3">
      <label class="form-label text-dark fw-semibold small text-uppercase" style="letter-spacing:.05em;">
        <i class="icofont icofont-lock me-1 text-primary"></i> Confirmar contraseña
      </label>
      <div class="input-group">
        <input id="new-password-confirm" type="password" class="form-control" placeholder="Repite la contraseña" autocomplete="new-password"
          #newPassConf (input)="checkNewPassMatch(newPass.value, newPassConf.value)">
        <button class="btn btn-outline-secondary" type="button"
          onclick="const el=document.getElementById('new-password-confirm');el.type=el.type==='password'?'text':'password'">
          <i class="icofont icofont-eye"></i>
        </button>
      </div>
      <div class="mt-1" *ngIf="newPass.value || newPassConf.value">
        <small *ngIf="passwordsNuevosCoinciden" class="text-success">
          <i class="icofont icofont-check-circled me-1"></i>Las contraseñas coinciden
        </small>
        <small *ngIf="!passwordsNuevosCoinciden" class="text-danger">
          <i class="icofont icofont-close-circled me-1"></i>Las contraseñas no coinciden
        </small>
      </div>
    </div>
  </div>

  <div class="modal-footer px-4 py-3 border-top" style="background:#f8fff8;">
    <button class="btn btn-outline-secondary btn-sm px-4" (click)="modal.dismiss()">Cancelar</button>
    <button class="btn btn-sm px-4 text-white fw-semibold bg-gradient-primary"
      (click)="crearUsuario(modal)">
      <i class="icofont icofont-check me-1"></i> Crear usuario
    </button>
  </div>
</ng-template>

<!-- Modal Editar Usuario -->
<ng-template #modalEditarUsuario let-modal>
  <div class="modal-header text-white border-0 bg-gradient-primary">
    <div class="d-flex align-items-center gap-3">
      <div class="rounded-circle d-flex align-items-center justify-content-center"
        style="width:42px;height:42px;background:rgba(255,255,255,0.2);font-size:1.3rem;flex-shrink:0;">
        <i class="icofont icofont-edit-alt"></i>
      </div>
      <div>
        <h5 class="modal-title mb-0 fw-bold">Editar usuario</h5>
        <small class="opacity-75">{{ usuarioEditar?.username }} &bull; ID: {{ usuarioEditar?.id }}</small>
      </div>
    </div>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body px-4 py-4">
    <div class="mb-3">
      <label class="form-label fw-semibold small text-uppercase text-dark" style="letter-spacing:.05em;">
        <i class="icofont icofont-user me-1 text-primary"></i> Usuario
      </label>
      <input id="edit-username" type="text" class="form-control"
        [value]="usuarioEditar?.username || ''" autocomplete="off">
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold small text-uppercase text-dark" style="letter-spacing:.05em;">
        <i class="icofont icofont-email me-1 text-primary"></i> Email
      </label>
      <input id="edit-email" type="email" class="form-control"
        [value]="usuarioEditar?.email || ''" autocomplete="off">
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold small text-uppercase text-dark" style="letter-spacing:.05em;">
        <i class="icofont icofont-users me-1 text-primary"></i> Rol
      </label>
      <select id="edit-role" class="form-select">
        <option value="">-- Sin rol --</option>
        <option *ngFor="let rol of roles" [value]="rol.id"
          [selected]="usuarioEditar?.roles?.[0]?.id === rol.id">
          {{ rol.nombre }}
        </option>
      </select>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold small text-uppercase text-dark" style="letter-spacing:.05em;">
        <i class="icofont icofont-ui-settings me-1 text-primary"></i> Estado
      </label>
      <select id="edit-estado" class="form-select">
        <option [value]="1" [selected]="usuarioEditar?.estado === 1">Activo</option>
        <option [value]="0" [selected]="usuarioEditar?.estado === 0">Inactivo</option>
      </select>
    </div>

    <hr class="my-3">
    <p class="text-dark small mb-2">
      <i class="icofont icofont-info-circle me-1"></i>
      Deja en blanco si no deseas cambiar la contraseña.
    </p>

    <div class="mb-3">
      <label class="form-label fw-semibold small text-uppercase text-dark" style="letter-spacing:.05em;">
        <i class="icofont icofont-lock me-1 text-primary"></i> Nueva contraseña
      </label>
      <div class="input-group">
        <input id="edit-password" type="password" class="form-control"
          placeholder="Nueva contraseña" autocomplete="new-password"
          #editPass (input)="checkPassMatch(editPass.value, editPassConf.value)">
        <button class="btn btn-outline-secondary" type="button"
          onclick="const el=document.getElementById('edit-password');el.type=el.type==='password'?'text':'password'">
          <i class="icofont icofont-eye"></i>
        </button>
      </div>
      <div class="form-text text-muted">Mínimo 8 caracteres.</div>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold small text-uppercase text-dark" style="letter-spacing:.05em;">
        <i class="icofont icofont-lock me-1 text-primary"></i> Confirmar contraseña
      </label>
      <div class="input-group">
        <input id="edit-password-confirm" type="password" class="form-control"
          placeholder="Repite la contraseña" autocomplete="new-password"
          #editPassConf (input)="checkPassMatch(editPass.value, editPassConf.value)">
        <button class="btn btn-outline-secondary" type="button"
          onclick="const el=document.getElementById('edit-password-confirm');el.type=el.type==='password'?'text':'password'">
          <i class="icofont icofont-eye"></i>
        </button>
      </div>
      <div class="mt-1" *ngIf="editPass.value || editPassConf.value">
        <small *ngIf="passwordsCoinciden" class="text-success">
          <i class="icofont icofont-check-circled me-1"></i>Las contraseñas coinciden
        </small>
        <small *ngIf="!passwordsCoinciden" class="text-danger">
          <i class="icofont icofont-close-circled me-1"></i>Las contraseñas no coinciden
        </small>
      </div>
    </div>
  </div>

  <div class="modal-footer px-4 py-3 border-top" style="background:#f0f8ff;">
    <button class="btn btn-outline-secondary btn-sm px-4" (click)="modal.dismiss()">Cancelar</button>
    <button class="btn btn-sm px-4 text-white fw-semibold"
      style="background:linear-gradient(135deg,#4f46e5,#7c3aed);"
      (click)="guardarEdicion(modal)">
      <i class="icofont icofont-save me-1"></i> Guardar
    </button>
  </div>
</ng-template>

<!-- Modal Vehículos del Usuario -->
<ng-template #modalVehiculos let-modal>
  <div class="modal-header text-white border-0 bg-gradient-primary">
    <div class="d-flex align-items-center gap-3">
      <div class="rounded-circle d-flex align-items-center justify-content-center"
        style="width:46px;height:46px;background:rgba(255,255,255,0.2);font-size:1.4rem;flex-shrink:0;">
        <i class="icofont icofont-car-alt-1"></i>
      </div>
      <div>
        <h5 class="modal-title mb-0 fw-bold">Asignación de vehículos</h5>
        <small class="opacity-75">{{ usuarioVehiculos?.username }} &bull; {{ usuarioVehiculos?.email }}</small>
      </div>
    </div>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body p-0">

    <!-- Loading -->
    <div *ngIf="loadingVehiculos" class="d-flex flex-column align-items-center justify-content-center py-5">
      <div class="spinner-border mb-3" style="width:2.5rem;height:2.5rem;color:#4f46e5;" role="status"></div>
      <span class="text-muted small">Cargando vehículos...</span>
    </div>

    <ng-container *ngIf="!loadingVehiculos">

      <!-- Banda de resumen -->
      <div class="d-flex align-items-center gap-4 px-4 py-3 border-bottom flex-wrap" style="background:#f8f9ff;">

        <!-- Buscador -->
        <div class="flex-grow-1">
          <div class="input-group input-group-sm">
            <span class="input-group-text bg-white" style="border-color:#4f46e5;">
              <i class="fa fa-search text-primary"></i>
            </span>
            <input type="text" class="form-control form-control-sm" style="border-color:#4f46e5;"
              placeholder="Filtrar por placa, marca o interno..."
              [(ngModel)]="searchVehiculo"
              (ngModelChange)="onSearchVehiculoChange()">
          </div>
        </div>

        <!-- Contadores -->
        <div class="text-center px-3 border-start">
          <div class="fw-bold fs-4 lh-1" style="color:#4f46e5;">{{ vehiculosAsignados.length }}</div>
          <div class="text-muted" style="font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;">Asignados</div>
        </div>
        <div class="text-center px-3 border-start">
          <div class="fw-bold fs-4 text-secondary lh-1">{{ todoVehiculos.length }}</div>
          <div class="text-muted" style="font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;">Total</div>
        </div>

        <!-- Mini barra de progreso -->
        <div class="px-3 border-start d-none d-md-block" style="min-width:90px;">
          <div class="progress mb-1" style="height:6px;border-radius:3px;">
            <div class="progress-bar"
              style="background:linear-gradient(90deg,#4f46e5,#7c3aed);"
              [style.width.%]="todoVehiculos.length ? (vehiculosAsignados.length / todoVehiculos.length) * 100 : 0">
            </div>
          </div>
          <div class="text-muted text-center" style="font-size:.7rem;">
            {{ todoVehiculos.length ? ((vehiculosAsignados.length / todoVehiculos.length) * 100 | number:'1.0-0') : 0 }}%
          </div>
        </div>
      </div>

      <!-- Instrucción -->
      <div class="px-4 pt-3 pb-2">
        <p class="mb-0 text-primary small">
          <i class="icofont icofont-info-circle me-1"></i>
          Marca los vehículos que deseas asignar a este usuario y guarda los cambios.
        </p>
        <div class="d-flex flex-wrap gap-2 mt-2">
          <button type="button" class="btn btn-xs px-2 py-1 text-white fw-semibold"
            style="font-size:.72rem;background:linear-gradient(135deg,#4f46e5,#7c3aed);border:none;border-radius:6px;"
            (click)="seleccionarTodosVehiculos()">
            <i class="icofont icofont-check-circled me-1"></i>Seleccionar todos
          </button>
          <button type="button" class="btn btn-xs px-2 py-1 fw-semibold"
            style="font-size:.72rem;border:1px solid #dc3545;color:#dc3545;background:#fff;border-radius:6px;"
            (click)="deseleccionarTodosVehiculos()">
            <i class="icofont icofont-close-circled me-1"></i>Deseleccionar todos
          </button>
        </div>
      </div>

      <!-- Sin vehículos disponibles -->
      <div *ngIf="todoVehiculos.length === 0" class="text-center py-5 text-muted">
        <i class="icofont icofont-car-alt-1 fs-1 d-block mb-2 opacity-50"></i>
        <p class="mb-0">No hay vehículos disponibles en el sistema.</p>
      </div>

      <!-- Sin resultados de búsqueda -->
      <div *ngIf="todoVehiculos.length > 0 && vehiculosFiltrados.length === 0" class="text-center py-4 text-muted">
        <i class="icofont icofont-search fs-2 d-block mb-2 opacity-50"></i>
        <p class="mb-0">No se encontraron vehículos con ese criterio.</p>
      </div>

      <!-- Grid de vehículos con checkboxes -->
      <div *ngIf="vehiculosFiltrados.length > 0" class="px-4 pb-3 pt-2">
        <div class="row g-2">
          <div class="col-12 col-md-6 col-xl-4" *ngFor="let v of vehiculosPaginados">
            <label [for]="'veh-' + v.placa"
              class="d-flex align-items-start gap-2 p-2 rounded border h-100"
              style="cursor:pointer;transition:all .15s;"
              [style.border-color]="tieneVehiculo(v.placa) ? '#4f46e5' : '#dee2e6'"
              [style.background]="tieneVehiculo(v.placa) ? '#eef2ff' : '#fff'">

              <!-- Checkbox -->
              <div class="pt-1 flex-shrink-0">
                <input
                  class="form-check-input m-0"
                  type="checkbox"
                  [id]="'veh-' + v.placa"
                  [checked]="tieneVehiculo(v.placa)"
                  (change)="toggleVehiculo(v.placa, $event)"
                  style="width:1.1rem;height:1.1rem;cursor:pointer;accent-color:#4f46e5;">
              </div>

              <!-- Info del vehículo -->
              <div class="overflow-hidden flex-grow-1">
                <div class="d-flex align-items-center gap-1 mb-1 flex-wrap">
                  <span class="badge fw-bold px-2"
                    [ngClass]="tieneVehiculo(v.placa) ? '' : 'text-bg-secondary'"
                    [style.background]="tieneVehiculo(v.placa) ? 'linear-gradient(135deg,#4f46e5,#7c3aed)' : ''"
                    [style.color]="tieneVehiculo(v.placa) ? '#fff' : ''"
                    style="font-size:.75rem;font-family:monospace;letter-spacing:.04em;">
                    {{ v.placa }}
                  </span>
                  <span *ngIf="v.interno" class="badge bg-light text-dark border" style="font-size:.68rem;">
                    #{{ v.interno }}
                  </span>
                </div>
                <p class="mb-0 text-truncate" style="font-size:.78rem;color:#495057;">
                  {{ v.marca || '' }} {{ v.linea || '' }}
                  <span *ngIf="v.modelo" class="text-muted">&bull; {{ v.modelo }}</span>
                </p>
                <p *ngIf="v.color || v.tipoServicio?.servicio" class="mb-0 text-muted"
                  style="font-size:.72rem;">
                  <span *ngIf="v.color">{{ v.color }}</span>
                  <span *ngIf="v.color && v.tipoServicio?.servicio"> &bull; </span>
                  <span *ngIf="v.tipoServicio?.servicio">{{ v.tipoServicio.servicio }}</span>
                </p>
              </div>

              <!-- Indicador asignado -->
              <div *ngIf="tieneVehiculo(v.placa)" class="flex-shrink-0 align-self-center">
                <i class="icofont icofont-check-circled text-primary" style="font-size:1.1rem;"></i>
              </div>
            </label>
          </div>
        </div>
      </div>

      <div class="d-flex flex-wrap justify-content-between align-items-center px-4 pb-4 gap-2"
        *ngIf="vehiculosFiltrados.length > 0">
        <small class="text-muted">
          Mostrando <strong>{{ (vehiculosPage - 1) * vehiculosPageSize + 1 }}</strong>–<strong>{{ vehiculosPage * vehiculosPageSize > vehiculosFiltrados.length ? vehiculosFiltrados.length : vehiculosPage * vehiculosPageSize }}</strong>
          de <strong>{{ vehiculosFiltrados.length }}</strong> vehículos
        </small>
        <ngb-pagination
          [(page)]="vehiculosPage"
          [pageSize]="vehiculosPageSize"
          [collectionSize]="vehiculosFiltrados.length"
          [maxSize]="5"
          [rotate]="true"
          [boundaryLinks]="true">
        </ngb-pagination>
        <select class="form-select form-select-sm rounded-pill" style="width:150px;"
          [(ngModel)]="vehiculosPageSize"
          (ngModelChange)="onVehiculosPageSizeChange()">
          <option [ngValue]="10">10 por página</option>
          <option [ngValue]="25">25 por página</option>
          <option [ngValue]="50">50 por página</option>
          <option [ngValue]="100">100 por página</option>
        </select>
      </div>

    </ng-container>
  </div>

  <!-- Footer -->
  <div class="modal-footer border-top px-4 py-3" style="background:#f8f9ff;">
    <span class="text-muted small me-auto">
      <i class="icofont icofont-info-circle me-1"></i>
      {{ vehiculosAsignados.length }} vehículo(s) seleccionado(s)
    </span>
    <button class="btn btn-outline-secondary btn-sm px-4" (click)="modal.dismiss()">Cancelar</button>
    <button class="btn btn-sm px-4 text-white fw-semibold bg-gradient-primary"
      (click)="guardarVehiculos(modal)">
      <i class="icofont icofont-save me-1"></i> Guardar asignación
    </button>
  </div>
</ng-template>

<!-- Modal Objetos de Contratos del Usuario -->
<ng-template #modalObjetosContratos let-modal>
  <div class="modal-header text-white border-0 bg-gradient-primary">
    <div class="d-flex align-items-center gap-3">
      <div class="rounded-circle d-flex align-items-center justify-content-center"
        style="width:46px;height:46px;background:rgba(255,255,255,0.2);font-size:1.4rem;flex-shrink:0;">
        <i class="icofont icofont-briefcase"></i>
      </div>
      <div>
        <h5 class="modal-title mb-0 fw-bold">Objetos de contrato</h5>
        <small class="opacity-75">{{ usuarioObjetosContratos?.username }} &bull; {{ usuarioObjetosContratos?.email }}</small>
      </div>
    </div>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body p-0">

    <!-- Loading -->
    <div *ngIf="loadingObjetosContratos" class="d-flex flex-column align-items-center justify-content-center py-5">
      <div class="spinner-border mb-3" style="width:2.5rem;height:2.5rem;color:#4f46e5;" role="status"></div>
      <span class="text-muted small">Cargando objetos de contrato...</span>
    </div>

    <ng-container *ngIf="!loadingObjetosContratos">

      <!-- Banda de resumen -->
      <div class="d-flex align-items-center gap-4 px-4 py-3 border-bottom flex-wrap" style="background:#f8f9ff;">

        <!-- Buscador -->
        <div class="flex-grow-1">
          <div class="input-group input-group-sm">
            <span class="input-group-text bg-white" style="border-color:#4f46e5;">
              <i class="fa fa-search text-primary"></i>
            </span>
            <input type="text" class="form-control form-control-sm" style="border-color:#4f46e5;"
              placeholder="Filtrar por descripción..."
              [(ngModel)]="searchObjetoContrato">
          </div>
        </div>

        <!-- Contadores -->
        <div class="text-center px-3 border-start">
          <div class="fw-bold fs-4 lh-1" style="color:#4f46e5;">{{ objetosContratosAsignados.length }}</div>
          <div class="text-muted" style="font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;">Asignados</div>
        </div>
        <div class="text-center px-3 border-start">
          <div class="fw-bold fs-4 text-secondary lh-1">{{ todoObjetosContratos.length }}</div>
          <div class="text-muted" style="font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;">Total</div>
        </div>

        <!-- Mini barra de progreso -->
        <div class="px-3 border-start d-none d-md-block" style="min-width:90px;">
          <div class="progress mb-1" style="height:6px;border-radius:3px;">
            <div class="progress-bar"
              style="background:linear-gradient(90deg,#4f46e5,#7c3aed);"
              [style.width.%]="todoObjetosContratos.length ? (objetosContratosAsignados.length / todoObjetosContratos.length) * 100 : 0">
            </div>
          </div>
          <div class="text-muted text-center" style="font-size:.7rem;">
            {{ todoObjetosContratos.length ? ((objetosContratosAsignados.length / todoObjetosContratos.length) * 100 | number:'1.0-0') : 0 }}%
          </div>
        </div>
      </div>

      <!-- Instrucción -->
      <div class="px-4 pt-3 pb-2">
        <p class="mb-0 text-primary small">
          <i class="icofont icofont-info-circle me-1"></i>
          Marca los objetos de contrato que deseas asignar a este usuario y guarda los cambios.
        </p>
        <div class="d-flex flex-wrap gap-2 mt-2">
          <button type="button" class="btn btn-xs px-2 py-1 text-white fw-semibold"
            style="font-size:.72rem;background:linear-gradient(135deg,#4f46e5,#7c3aed);border:none;border-radius:6px;"
            (click)="seleccionarTodosObjetosContratos()">
            <i class="icofont icofont-check-circled me-1"></i>Seleccionar todos los objetos
          </button>
          <button type="button" class="btn btn-xs px-2 py-1 fw-semibold"
            style="font-size:.72rem;border:1px solid #dc3545;color:#dc3545;background:#fff;border-radius:6px;"
            (click)="deseleccionarTodosObjetosContratos()">
            <i class="icofont icofont-close-circled me-1"></i>Deseleccionar todos
          </button>
         
          <button type="button" class="btn btn-xs px-2 py-1 fw-semibold"
            style="font-size:.72rem;border:1px solid #198754;color:#198754;background:#fff;border-radius:6px;"
            (click)="toggleFuecTodosObjetosContratos()">
            <i class="icofont icofont-refresh me-1"></i>Asignar FUEC
          </button>
          <button type="button" class="btn btn-xs px-2 py-1 fw-semibold"
            style="font-size:.72rem;border:1px solid #198754;color:#198754;background:#fff;border-radius:6px;"
            (click)="toggleContratoTodosObjetosContratos()">
            <i class="icofont icofont-refresh me-1"></i>Asignar contrato
          </button>
        </div>
      </div>

      <!-- Sin objetos -->
      <div *ngIf="todoObjetosContratos.length === 0" class="text-center py-5 text-muted">
        <i class="icofont icofont-briefcase fs-1 d-block mb-2 opacity-50"></i>
        <p class="mb-0">No hay objetos de contrato disponibles en el sistema.</p>
      </div>

      <!-- Sin resultados de búsqueda -->
      <div *ngIf="todoObjetosContratos.length > 0 && objetosContratosFiltrados.length === 0" class="text-center py-4 text-muted">
        <i class="icofont icofont-search fs-2 d-block mb-2 opacity-50"></i>
        <p class="mb-0">No se encontraron objetos con ese criterio.</p>
      </div>

      <!-- Grid de objetos con checkboxes -->
      <div *ngIf="objetosContratosFiltrados.length > 0" class="px-4 pb-4 pt-2">
        <div class="row g-2">
          <div class="col-12 col-md-6 col-xl-4" *ngFor="let o of objetosContratosFiltrados">
            <label [for]="'obj-' + o.id"
              class="d-flex align-items-start gap-2 p-2 rounded border h-100"
              style="cursor:pointer;transition:all .15s;"
              [style.border-color]="tieneObjetoContrato(o.id) ? '#4f46e5' : '#dee2e6'"
              [style.background]="tieneObjetoContrato(o.id) ? '#eef2ff' : '#fff'">

              <!-- Checkbox -->
              <div class="pt-1 flex-shrink-0">
                <input
                  class="form-check-input m-0"
                  type="checkbox"
                  [id]="'obj-' + o.id"
                  [checked]="tieneObjetoContrato(o.id)"
                  (change)="toggleObjetoContrato(o.id, $event)"
                  style="width:1.1rem;height:1.1rem;cursor:pointer;accent-color:#4f46e5;">
              </div>

              <!-- Info del objeto -->
              <div class="overflow-hidden flex-grow-1">
                <div class="mb-1 d-flex flex-wrap gap-1 align-items-center">
                  <span class="badge fw-bold px-2"
                    [ngClass]="tieneObjetoContrato(o.id) ? '' : 'text-bg-secondary'"
                    [style.background]="tieneObjetoContrato(o.id) ? 'linear-gradient(135deg,#4f46e5,#7c3aed)' : ''"
                    [style.color]="tieneObjetoContrato(o.id) ? '#fff' : ''"
                    style="font-size:.68rem;font-family:monospace;">
                    #{{ o.id }}
                  </span>
                  <span class="badge rounded-pill"
                    [ngClass]="o.isFuec === 1 ? 'text-bg-success' : 'text-bg-light text-muted border'"
                    style="font-size:.64rem;">
                    FUEC {{ o.isFuec === 1 ? 'ON' : 'OFF' }}
                  </span>
                  <span class="badge rounded-pill"
                    [ngClass]="o.isContrato === 1 ? 'text-bg-info' : 'text-bg-light text-muted border'"
                    style="font-size:.64rem;">
                    CONTRATO {{ o.isContrato === 1 ? 'ON' : 'OFF' }}
                  </span>
                </div>
                <div class="d-flex flex-wrap gap-2 mb-1" (click)="$event.stopPropagation()">
                  <div class="form-check form-switch mb-0">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [id]="'obj-fuec-' + o.id"
                      [checked]="o.isFuec === 1"
                      (click)="$event.stopPropagation()"
                      (change)="toggleObjetoFuec(o, $event)"
                      style="cursor:pointer;">
                    <label class="form-check-label text-dark" [for]="'obj-fuec-' + o.id" style="font-size:.7rem;">
                      Puede hacer FUEC
                    </label>
                  </div>
                  <div class="form-check form-switch mb-0">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [id]="'obj-contrato-' + o.id"
                      [checked]="o.isContrato === 1"
                      (click)="$event.stopPropagation()"
                      (change)="toggleObjetoContratoTipo(o, $event)"
                      style="cursor:pointer;">
                    <label class="form-check-label text-dark" [for]="'obj-contrato-' + o.id" style="font-size:.7rem;">
                      Contrato
                    </label>
                  </div>
                </div>
                <p class="mb-0 fw-semibold" style="font-size:.8rem;color:#212529;line-height:1.3;">
                  {{ o.descripcion || 'Sin descripción' }}
                </p>
              </div>

              <!-- Indicador asignado -->
              <div *ngIf="tieneObjetoContrato(o.id)" class="flex-shrink-0 align-self-center">
                <i class="icofont icofont-check-circled text-primary" style="font-size:1.1rem;"></i>
              </div>
            </label>
          </div>
        </div>
      </div>

    </ng-container>
  </div>

  <!-- Footer -->
  <div class="modal-footer border-top px-4 py-3" style="background:#f8f9ff;">
    <span class="text-muted small me-auto">
      <i class="icofont icofont-info-circle me-1"></i>
      {{ totalObjetosSeleccionados }} seleccionado(s) | FUEC: {{ totalObjetosConFuecSeleccionados }} | Contrato: {{ totalObjetosConContratoSeleccionados }}
    </span>
    <button class="btn btn-outline-secondary btn-sm px-4" (click)="modal.dismiss()">Cancelar</button>
    <button class="btn btn-sm px-4 text-white fw-semibold bg-gradient-primary"
      (click)="guardarObjetosContratos(modal)">
      <i class="icofont icofont-save me-1"></i> Guardar asignación
    </button>
  </div>
</ng-template>

<!-- Modal Contratistas del Usuario -->
<ng-template #modalContratistas let-modal>
  <div class="modal-header text-white border-0 bg-gradient-primary">
    <div class="d-flex align-items-center gap-3">
      <div class="rounded-circle d-flex align-items-center justify-content-center"
        style="width:46px;height:46px;background:rgba(255,255,255,0.2);font-size:1.4rem;flex-shrink:0;">
        <i class="icofont icofont-people"></i>
      </div>
      <div>
        <h5 class="modal-title mb-0 fw-bold">Asignación de contratistas</h5>
        <small class="opacity-75">{{ usuarioContratista?.username }} &bull; {{ usuarioContratista?.email }}</small>
      </div>
    </div>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body p-0">

    <!-- Loading -->
    <div *ngIf="loadingContratistas" class="d-flex flex-column align-items-center justify-content-center py-5">
      <div class="spinner-border mb-3" style="width:2.5rem;height:2.5rem;color:#4f46e5;" role="status"></div>
      <span class="text-muted small">Cargando contratistas...</span>
    </div>

    <ng-container *ngIf="!loadingContratistas">

      <!-- Banda de resumen -->
      <div class="d-flex align-items-center gap-4 px-4 py-3 border-bottom flex-wrap" style="background:#f8f9ff;">

        <!-- Buscador -->
        <div class="flex-grow-1">
          <div class="input-group input-group-sm">
            <span class="input-group-text bg-white" style="border-color:#4f46e5;">
              <i class="fa fa-search text-primary"></i>
            </span>
            <input type="text" class="form-control form-control-sm" style="border-color:#4f46e5;"
              placeholder="Filtrar por NIT o nombre..."
              [(ngModel)]="searchContratista"
              (ngModelChange)="onSearchContratistaChange()">
          </div>
        </div>

        <!-- Contadores -->
        <div class="text-center px-3 border-start">
          <div class="fw-bold fs-4 lh-1" style="color:#4f46e5;">{{ contratistasAsignados.length }}</div>
          <div class="text-muted" style="font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;">Asignados</div>
        </div>
        <div class="text-center px-3 border-start">
          <div class="fw-bold fs-4 text-secondary lh-1">{{ todoContratistas.length }}</div>
          <div class="text-muted" style="font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;">Total</div>
        </div>

        <!-- Mini barra de progreso -->
        <div class="px-3 border-start d-none d-md-block" style="min-width:90px;">
          <div class="progress mb-1" style="height:6px;border-radius:3px;">
            <div class="progress-bar"
              style="background:linear-gradient(90deg,#4f46e5,#7c3aed);"
              [style.width.%]="todoContratistas.length ? (contratistasAsignados.length / todoContratistas.length) * 100 : 0">
            </div>
          </div>
          <div class="text-muted text-center" style="font-size:.7rem;">
            {{ todoContratistas.length ? ((contratistasAsignados.length / todoContratistas.length) * 100 | number:'1.0-0') : 0 }}%
          </div>
        </div>
      </div>

      <!-- Instrucción -->
      <div class="px-4 pt-3 pb-2">
        <p class="mb-0 text-primary small">
          <i class="icofont icofont-info-circle me-1"></i>
          Marca los contratistas que deseas asignar a este usuario y guarda los cambios.
        </p>
        <div class="d-flex flex-wrap gap-2 mt-2">
          <button type="button" class="btn btn-xs px-2 py-1 text-white fw-semibold"
            style="font-size:.72rem;background:linear-gradient(135deg,#4f46e5,#7c3aed);border:none;border-radius:6px;"
            (click)="seleccionarTodosContratistas()">
            <i class="icofont icofont-check-circled me-1"></i>Seleccionar todos
          </button>
          <button type="button" class="btn btn-xs px-2 py-1 fw-semibold"
            style="font-size:.72rem;border:1px solid #dc3545;color:#dc3545;background:#fff;border-radius:6px;"
            (click)="deseleccionarTodosContratistas()">
            <i class="icofont icofont-close-circled me-1"></i>Deseleccionar todos
          </button>
        </div>
      </div>

      <!-- Sin contratistas disponibles -->
      <div *ngIf="todoContratistas.length === 0" class="text-center py-5 text-muted">
        <i class="icofont icofont-people fs-1 d-block mb-2 opacity-50"></i>
        <p class="mb-0">No hay contratistas disponibles en el sistema.</p>
      </div>

      <!-- Sin resultados de búsqueda -->
      <div *ngIf="todoContratistas.length > 0 && contratistasFiltrados.length === 0" class="text-center py-4 text-muted">
        <i class="icofont icofont-search fs-2 d-block mb-2 opacity-50"></i>
        <p class="mb-0">No se encontraron contratistas con ese criterio.</p>
      </div>

      <!-- Grid de contratistas con checkboxes -->
      <div *ngIf="contratistasFiltrados.length > 0" class="px-4 pb-3 pt-2">
        <div class="row g-2">
          <div class="col-12 col-md-6 col-xl-4" *ngFor="let c of contratistasPaginados">
            <label [for]="'cont-' + c.nit"
              class="d-flex align-items-start gap-2 p-2 rounded border h-100"
              style="cursor:pointer;transition:all .15s;"
              [style.border-color]="tieneContratista(c.nit) ? '#4f46e5' : '#dee2e6'"
              [style.background]="tieneContratista(c.nit) ? '#eef2ff' : '#fff'">

              <!-- Checkbox -->
              <div class="pt-1 flex-shrink-0">
                <input
                  class="form-check-input m-0"
                  type="checkbox"
                  [id]="'cont-' + c.nit"
                  [checked]="tieneContratista(c.nit)"
                  (change)="toggleContratista(c.nit, $event)"
                  style="width:1.1rem;height:1.1rem;cursor:pointer;accent-color:#4f46e5;">
              </div>

              <!-- Info del contratista -->
              <div class="overflow-hidden flex-grow-1">
                <div class="d-flex align-items-center gap-1 mb-1 flex-wrap">
                  <span class="badge fw-bold px-2"
                    [ngClass]="tieneContratista(c.nit) ? '' : 'text-bg-secondary'"
                    [style.background]="tieneContratista(c.nit) ? 'linear-gradient(135deg,#4f46e5,#7c3aed)' : ''"
                    [style.color]="tieneContratista(c.nit) ? '#fff' : ''"
                    style="font-size:.72rem;font-family:monospace;letter-spacing:.02em;">
                    {{ c.nit }}
                  </span>
                </div>
                <p class="mb-0 fw-semibold text-truncate" style="font-size:.8rem;color:#212529;">
                  {{ c.nombre || c.razon_social || 'Sin nombre' }}
                </p>
              </div>

              <!-- Indicador asignado -->
              <div *ngIf="tieneContratista(c.nit)" class="flex-shrink-0 align-self-center">
                <i class="icofont icofont-check-circled text-primary" style="font-size:1.1rem;"></i>
              </div>
            </label>
          </div>
        </div>
      </div>

      <div class="d-flex flex-wrap justify-content-between align-items-center px-4 pb-4 gap-2"
        *ngIf="contratistasFiltrados.length > 0">
        <small class="text-muted">
          Mostrando <strong>{{ (contratistasPage - 1) * contratistasPageSize + 1 }}</strong>–<strong>{{ contratistasPage * contratistasPageSize > contratistasFiltrados.length ? contratistasFiltrados.length : contratistasPage * contratistasPageSize }}</strong>
          de <strong>{{ contratistasFiltrados.length }}</strong> contratistas
        </small>
        <ngb-pagination
          [(page)]="contratistasPage"
          [pageSize]="contratistasPageSize"
          [collectionSize]="contratistasFiltrados.length"
          [maxSize]="5"
          [rotate]="true"
          [boundaryLinks]="true">
        </ngb-pagination>
        <select class="form-select form-select-sm rounded-pill" style="width:150px;"
          [(ngModel)]="contratistasPageSize"
          (ngModelChange)="onContratistasPageSizeChange()">
          <option [ngValue]="10">10 por página</option>
          <option [ngValue]="25">25 por página</option>
          <option [ngValue]="50">50 por página</option>
          <option [ngValue]="100">100 por página</option>
        </select>
      </div>

    </ng-container>
  </div>

  <!-- Footer -->
  <div class="modal-footer border-top px-4 py-3" style="background:#f8f9ff;">
    <span class="text-muted small me-auto">
      <i class="icofont icofont-info-circle me-1"></i>
      {{ contratistasAsignados.length }} contratista(s) seleccionado(s)
    </span>
    <button class="btn btn-outline-secondary btn-sm px-4" (click)="modal.dismiss()">Cancelar</button>
    <button class="btn btn-sm px-4 text-white fw-semibold bg-gradient-primary"
      (click)="guardarContratistas(modal)">
      <i class="icofont icofont-save me-1"></i> Guardar asignación
    </button>
  </div>
</ng-template>
